module.exports = __webpack_public_path__ + "media/tile-3-image.665c5244.png";